import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CHANNEL_APP } from '../config/tokens.config';
import { ChannelAppType } from '../enum/channel-app-type.enum';

@Injectable({ providedIn: 'root' })
export class NotificationService {
    constructor(
        private http: HttpClient,
        @Inject(CHANNEL_APP) private channelApp: ChannelAppType
    ) {}

    get(notificationUrl: string) {
        const channelId: any = this.channelApp;
        return this.http.get(`${notificationUrl}/notification/active`, {
            params: { channelId },
        });
    }
}
